import get from 'lodash.get';
import toPairs from 'lodash.topairs';
import fromPairs from 'lodash.frompairs';
import { DISCONTINUE_KEY, TESTED_OUT_KEY } from '../../constants/gatingRules';

export const getGatedMeasuresStatusForLectura = (appStatuses, period) => {
    const status = get(appStatuses.idel2[period], 'gatedMeasuresStatus', {});

    const asArrayOfEntries = toPairs(status);
    return {
        [DISCONTINUE_KEY]: fromPairs(
            // eslint-disable-next-line no-unused-vars
            asArrayOfEntries.filter(([key, value]) => value.gatingType === DISCONTINUE_KEY) ?? {},
        ),
        [TESTED_OUT_KEY]: fromPairs(
            // eslint-disable-next-line no-unused-vars
            asArrayOfEntries.filter(([key, value]) => value.gatingType === TESTED_OUT_KEY) ?? {},
        ),
    };
};
